import { CurrencyUtil } from '@aperza/util';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export const useSellerShippingPrice = () => {
    const { t } = useTranslation();
    const unlimited = t('seller.shippingFee.unlimited');
    let [locations, setLocations] = useState([]);
    let [tableConfig, setTableConfig] = useState();
    const updateLocations = (_locations) => {
        setLocations(_locations);
    };
    useEffect(() => {
        /// TODO : Sort Base Shipping Fees
        let sortedBaseShippingFeesColumns = new Set();
        let sortedAdditionalShippingFeesWeightColumns = new Set();
        let sortedAdditionalShippingFeesQuantityColumns = new Set();
        let data = locations.map((location) => {
            let baseShippingFees = {};
            /// TODO : BASE SHIPPING FEES
            location.baseShippingFees.forEach((fee) => {
                let columnName = CurrencyUtil.parseCurrency(fee.priceFrom) +
                    '~' +
                    (fee.priceTo ? CurrencyUtil.parseCurrency(fee.priceTo) : unlimited);
                sortedBaseShippingFeesColumns.add(columnName);
                baseShippingFees[columnName] =
                    fee.shippingFee > 0 ? CurrencyUtil.parseCurrency(fee.shippingFee, true) : fee.shippingFee;
            });
            /// TODO : additional Shipping Fee for the weight
            let additionalShippingFeesWeight = location.additionalShippingFeesWeight.map((fee) => {
                sortedAdditionalShippingFeesWeightColumns.add('id_w_' + fee.shippingPlanDisplayId);
                return {
                    shippingPlanDisplayId: fee.shippingPlanDisplayId,
                    referenceWeight: fee.referenceWeight,
                    shippingFeePerAdditionalKilo: fee.shippingFeePerAdditionalKilo,
                    shippingFee: fee.shippingFee,
                };
            });
            /// TODO : additional Shipping Fee for the quantity
            let additionalShippingFeesQuantity = location.additionalShippingFeesQuantity.map((fee) => {
                sortedAdditionalShippingFeesQuantityColumns.add('id_q_' + fee.shippingPlanDisplayId);
                return {
                    shippingPlanDisplayId: fee.shippingPlanDisplayId,
                    shippingFeePerAdditionalQuantity: fee.shippingFeePerAdditionalQuantity,
                    shippingFee: fee.shippingFee,
                };
            });
            return {
                locationCode: location.locationCode,
                locationName: location.locationName,
                baseShippingFees: baseShippingFees,
                additionalShippingFeesWeight: additionalShippingFeesWeight,
                additionalShippingFeesQuantity: additionalShippingFeesQuantity,
            };
        });
        setTableConfig({
            data,
            sortedBaseShippingFeesColumns,
            sortedAdditionalShippingFeesWeightColumns,
            sortedAdditionalShippingFeesQuantityColumns,
        });
    }, [locations]);
    return {
        updateLocations,
        tableConfig,
    };
};
